import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./customer_identifier_input_method.js";
//#region src/customer_identifier_input_method_helper.ts
var customer_identifier_input_method_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(inputMethod) {
	switch (inputMethod) {
		case 1: return "Number (Auto-Generated)";
		case 2: return "Name Text Field";
		case 3: return "Table Tent Picker";
		case 4: return "Table Tracker Picker";
		case 5: return "Numeric Text Field";
		case 6: return "Vehicle Details Form (Name/Make/Model/Color)";
		case 7: return "Address Form (Street, Apt/Number, City, State, Postal Code)";
		case 8: return "Phone Number Form";
		case 9: return "Email Input Field";
	}
}
//#endregion
export { customer_identifier_input_method_helper_exports, name };

//# sourceMappingURL=customer_identifier_input_method_helper.js.map